import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface BulenoxAccount {
  size: string;
  contracts: string;
}

@Component({
  selector: 'app-bulenox-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './bulenox-banner.component.html'
})
export class BulenoxBannerComponent {
  @Input() optionLabel = 'Option 1 Accounts';
  @Input() discount = '89% OFF';
  @Input() couponCode = 'PROPDESK';
  @Input() expiry = '';
  @Input() link = 'https://bulenox.com/';
  @Input() accounts: BulenoxAccount[] = [
    { size: '$25K',  contracts: '3 Contracts' },
    { size: '$50K',  contracts: '7 Contracts' },
    { size: '$100K', contracts: '12 Contracts' },
    { size: '$150K', contracts: '15 Contracts' },
  ];

  copied = false;

  copyCode(event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    navigator.clipboard.writeText(this.couponCode).then(() => {
      this.copied = true;
      setTimeout(() => { this.copied = false; }, 2000);
    });
  }
}
